import CheckDepositDetails from 'features/rdc/screens/CheckDepositHistory/CheckDepositHistoryDetails/CheckDepositDetails';
import React from 'react';

export default function Page() {
  return <CheckDepositDetails />;
}
